/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateDraftPreviewSessionRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {CreateDraftPreviewSessionResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const createDraftPreviewSession = (request: CreateDraftPreviewSessionRequest, options?: CashRequestOptions) => post<CreateDraftPreviewSessionRequest, CreateDraftPreviewSessionResponse>("/2.0/cash/create-draft-preview-session", request, {...options, rejectOnError: true })